/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sponsor_Edit_ClearInputs */



/**
* | output |
* | --- |
* | "Clear sponsor" |
*
* @param {Sponsor_Edit_ClearInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sponsor_edit_clear = /** @type {((inputs?: Sponsor_Edit_ClearInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sponsor_Edit_ClearInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Effacer le parrain")
	if (locale === "es") return /** @type {LocalizedString} */ ("Borrar avalista")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Remover padrinho")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rimuovi sponsor")
	return /** @type {LocalizedString} */ ("Clear sponsor")
});